import React from 'react';
import { useTheme } from 'components/common/ThemeContext';
import { BiGridAlt } from 'react-icons/bi';
import { AiOutlineCalendar } from 'react-icons/ai';
import { useLocation, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const { theme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  console.log('location', path);

  // Define color based on theme and path
  const getColor = (currentPath) =>
    path === currentPath
      ? theme === 'dark' || theme === 'light'
        ? 'text-[#9757F6]'
        : 'text-[#0D0D0B]'
      : theme === 'dark'
      ? 'text-[#FFF]'
      : 'text-[#0D0D0B]';

  return (
    <div className='px-5'>
      <p className='text-[#9757F6] text-[35px] font-bold font-InterBold mt-[42px]'>SAM</p>
      <div className='flex items-center'>
        <p className='dark:text-white mr-3 text-black text-[16px] font-bold font-InterBold'>Powered by </p>
        <img
          alt="logo"
          src={theme === 'dark' ? '/logo-wide.png' : '/dark-logo.png'}
          className='w-[113px] h-[29px] object-contain'
        />
      </div>
      <div className='px-7 mt-6'>
        <p className='font-Inter text-[13px] dark:text-white'>Menu</p>
        <div
          className='flex mt-6 items-center cursor-pointer'
          onClick={() => navigate('/')}
        >
          <BiGridAlt className={`w-[20px] h-[20px] mr-5 ${getColor('/')}`} />
          <p className={`font-Inter text-[16px] font-bold ${getColor('/')}`}>Dashboard</p>
        </div>
        <div
          className='flex mt-6 items-center cursor-pointer'
          onClick={() => navigate('/history')}
        >
          <AiOutlineCalendar className={`w-[20px] h-[20px] mr-5 ${getColor('/history')}`} />
          <p className={`font-Inter text-[16px] font-bold ${getColor('/history')}`}>History</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
